var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"downloadWrapper"},[_c('download-icon',{staticClass:"downloadIcon"}),_vm._v(" "),_c('a',{attrs:{"href":_vm.config.url,"download":"","target":"_blank"}},[_vm._v(_vm._s(_vm.translatedLabel))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }